import React, { useEffect, useState } from "react"
import { Row, Col } from "reactstrap"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import Swal from "sweetalert2"
import secureLocalStorage from "react-secure-storage"
import Loader from "pages/Separate/Loader"
import { fetchNodeData, FetchNodePostData } from "utils/common-fetchData"

// There is only one guidelines/policy record: this page loads it and saves back to the same record.
const GuidelinesPolicy = () => {
  const [isLoading, setLoading] = useState(false)
  const [content, setContent] = useState("")

  useEffect(() => {
    const getPolicy = async () => {
      const response = await fetchNodeData(
        setLoading,
        "companyPolicy/get",
        secureLocalStorage.getItem("auth_token")
      )
      if (response?.success) {
        setContent(response.data?.content || "")
      }
    }
    getPolicy()
  }, [])

  const handleSave = async e => {
    e.preventDefault()
    const response = await FetchNodePostData(
      setLoading,
      "companyPolicy/save",
      secureLocalStorage.getItem("auth_token"),
      {
        content: content,
        updated_by: localStorage.getItem("auth_id"),
      }
    )
    if (response?.data?.success) {
      Swal.fire("Saved!", "Guidelines and policy updated successfully.", "success")
    } else {
      Swal.fire("Error", "Unable to save guidelines and policy.", "error")
    }
  }

  return (
    <>
      {isLoading && <Loader />}
      <form onSubmit={handleSave}>
        <Row className="align-items-center mb-4">
          <Col>
            <h5 className="mb-0 text-dark">General Guidelines & Policy</h5>
          </Col>
          <Col className="text-end">
            <button type="submit" className="btn btn-save btn-label">
              <i className="fas fa-save me-2 label-icon"></i>SAVE
            </button>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <CKEditor
              editor={ClassicEditor}
              data={content}
              onChange={(_event, editor) => setContent(editor.getData())}
            />
          </Col>
        </Row>
      </form>
    </>
  )
}

export default GuidelinesPolicy
